import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0810 = React.lazy(() => import('./symbols/0810_heart_pulse_rate_health'));
const Symbol0811 = React.lazy(() => import('./symbols/0811_medicine_health_injection_ill'));
const Symbol0812 = React.lazy(() => import('./symbols/0812_medicine_patch_injury'));
const Symbol0813 = React.lazy(() => import('./symbols/0813_heart_vitals_pulse_rate_health'));
const Symbol0814 = React.lazy(() => import('./symbols/0814_kidney_internal_body_part'));
const Symbol0815 = React.lazy(() => import('./symbols/0815_lungs_breathing'));
const Symbol0816 = React.lazy(() => import('./symbols/0816_microscope_laboratory'));
const Symbol0817 = React.lazy(() => import('./symbols/0817_tube_laboratory_chemistry'));
const Symbol0818 = React.lazy(() => import('./symbols/0818_poison_pills_drugs'));
const Symbol0819 = React.lazy(() => import('./symbols/0819_poison_deathly_medicine'));
const Symbol0820 = React.lazy(() => import('./symbols/0820_medicine_drugs_ill_pill'));
const Symbol0821 = React.lazy(() => import('./symbols/0821_blood_infusion'));
const Symbol0822 = React.lazy(() => import('./symbols/0822_blood_infusion'));
const Symbol0823 = React.lazy(
  () => import('./symbols/0823_hospital_ill_medicine_doctor_ambulance')
);
const Symbol0824 = React.lazy(() => import('./symbols/0824_fever_body_temperature_ill'));
const Symbol0825 = React.lazy(() => import('./symbols/0825_stetoscope_doctor_hospital_ill'));
const Symbol0826 = React.lazy(() => import('./symbols/0826_teeth_tooth_dental'));
const Symbol0827 = React.lazy(() => import('./symbols/0827_body_weight_fitness_health_fat'));

export interface IProps {}

const Medicine: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0810_heart_pulse_rate_health" symbol={<Symbol0810 />} />
      <LazySymbol id="0811_medicine_health_injection_ill" symbol={<Symbol0811 />} />
      <LazySymbol id="0812_medicine_patch_injury" symbol={<Symbol0812 />} />
      <LazySymbol id="0813_heart_vitals_pulse_rate_health" symbol={<Symbol0813 />} />
      <LazySymbol id="0814_kidney_internal_body_part" symbol={<Symbol0814 />} />
      <LazySymbol id="0815_lungs_breathing" symbol={<Symbol0815 />} />
      <LazySymbol id="0816_microscope_laboratory" symbol={<Symbol0816 />} />
      <LazySymbol id="0817_tube_laboratory_chemistry" symbol={<Symbol0817 />} />
      <LazySymbol id="0818_poison_pills_drugs" symbol={<Symbol0818 />} />
      <LazySymbol id="0819_poison_deathly_medicine" symbol={<Symbol0819 />} />
      <LazySymbol id="0820_medicine_drugs_ill_pill" symbol={<Symbol0820 />} />
      <LazySymbol id="0821_blood_infusion" symbol={<Symbol0821 />} />
      <LazySymbol id="0822_blood_infusion" symbol={<Symbol0822 />} />
      <LazySymbol id="0823_hospital_ill_medicine_doctor_ambulance" symbol={<Symbol0823 />} />
      <LazySymbol id="0824_fever_body_temperature_ill" symbol={<Symbol0824 />} />
      <LazySymbol id="0825_stetoscope_doctor_hospital_ill" symbol={<Symbol0825 />} />
      <LazySymbol id="0826_teeth_tooth_dental" symbol={<Symbol0826 />} />
      <LazySymbol id="0827_body_weight_fitness_health_fat" symbol={<Symbol0827 />} />
    </>
  );
});

Medicine.displayName = 'Medicine';

export default Medicine;
